module.exports = __webpack_public_path__ + "img/shipo-home-vessel.71f661ef.svg";